// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".opencicc[data-v-61845492]{background:#fff;max-width:62.5rem;margin:0 auto;padding:1.041667rem}", ""]);
// Exports
module.exports = exports;
